












































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class HeaderNotify extends Vue {

  private loadding: boolean = false;

  get theme() {
      return 'dark';
    }

  private fetchNotice() {
      if (this.loadding) {
        this.loadding = false;
        return;
      }
      this.loadding = true;
      setTimeout(() => {
        this.loadding = false;
      }, 2000);
    }
}
